import React from 'react'

export default () => (
    <div className="new-container container-cards-mercos-customers">
        <div className="container-cards">
            <a className="rounded-card" href="/industrias/">
                <img className="icon" src="/images/site/content/icone-industrias.png" alt="Mercos: ideal para Indústrias" />
                <h3>Mercos para<br/> <b>Indústrias</b></h3>
                <div className="checklist">
                    <div className="checklist-item">
                        <div className="checkmark"></div>
                        <p><b>Controle seu processo</b>: emita pedidos em tempo real e ganhe agilidade.</p>
                    </div>
                    <div className="checklist-item">
                        <div className="checkmark"></div>
                        <p><b>Sem retrabalho</b>: pedidos corretos,   atualizados e integrados ao ERP.</p>
                    </div>
                    <div className="checklist-item">
                        <div className="checkmark"></div>
                        <p><b>Gestão da equipe</b>: acompanhe relatórios e indicadores de vendas.  </p>
                    </div>
                </div>
                <button className="know-more-button">saiba mais</button>
            </a>


            <a className="rounded-card" href="/distribuidoras/">
                <img className="icon" src="/images/site/content/icone-distribuidoras.png" alt="Mercos: ideal para Distribuidoras" />
                <h3>Mercos para<br/> <b>Distribuidoras</b></h3>

                <div className="checklist">
                    <div className="checklist-item">
                        <div className="checkmark"></div>
                        <p><b>Ganhe tempo</b>: emissão de pedidos completos de forma automática.</p>
                    </div>
                    <div className="checklist-item">
                        <div className="checkmark"></div>
                        <p><b>Controle do estoque</b>: integre ao ERP e mantenha seu estoque organizado.</p>
                    </div>
                    <div className="checklist-item">
                        <div className="checkmark"></div>
                        <p><b>Equipes eficientes</b>: informações atualizadas para melhorar as vendas. </p>
                    </div>
                </div>
                <button className="know-more-button">saiba mais</button>
            </a>


            <a className="rounded-card" href="/representantes-comerciais/">
                <img className="icon" src="/images/site/content/icone-representantes.png" alt="Mercos: ideal para Representantes Comerciais" />
                <h3>Mercos para<br/> <b>Representantes</b></h3>
                <div className="checklist">
                    <div className="checklist-item">
                        <div className="checkmark"></div>
                        <p><b>App de vendas</b>: dados de clientes, produtos e representadas na sua mão.</p>
                    </div>
                    <div className="checklist-item">
                        <div className="checkmark"></div>
                        <p><b>Venda offline</b>: emita pedidos mesmo quando estiver sem internet</p>
                    </div>
                    <div className="checklist-item">
                        <div className="checkmark"></div>
                        <p><b>Organize seus processos</b>: acesse relatórios de resultados e comissões.</p>
                    </div>
                </div>
                <button className="know-more-button" >saiba mais</button>
            </a>
        </div>
    </div>
)


// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/CardsMercosCustomers/CardsMercosCustomersv3.jsx